import type { SupportedLanguage } from '../languages';
import type { Messages } from './en';

export type { Messages };

/**
 * Dictionaries are code-split per language: a patient reading English never
 * downloads Arabic. `en` is also the fallback for any key a translation lacks.
 */
export function loadMessages(language: SupportedLanguage): Promise<Messages> {
  switch (language) {
    case 'ar':
      return import('./ar').then((m) => m.default);
    case 'es':
      return import('./es').then((m) => m.default);
    case 'it':
      return import('./it').then((m) => m.default);
    default:
      return import('./en').then((m) => m.default);
  }
}
